/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8.20.20
Meter Summary: Simple meter table or irrigation
***********************************************************/
import React, { Component } from 'react';
import { sumProp, avgProp } from '../../irrigation_utils';
class MeterSummary extends Component {
  render() {
    return (
      <ul className="collection z-depth-1 with-header">
        <li className="collection-item avatar">
          <i className="material-icons cyan circle">insert_chart</i>
          <p className="flow-text">Meter Summary</p>
          <p className>By Meter</p>
        </li>
        <li className="collection-item">
          <table className="highlight bordered responsive-table centered">
            <thead>
              <tr>
                <th>Meter</th>
                <th>Starting Gallons (M)</th>
                <th>Ending Gallons (M)</th>
                <th>Totals Gallons (M)</th>
                <th>Average Gallons (M)</th>
              </tr>
            </thead>
          <tbody>
            {
              this.props.meterTotals.map((m) => (
                <tr key={m.key}>
                  <td>{ m.key }</td>
                  <td>{ m.startGal }</td>
                  <td>{ m.endGal }</td>
                  <td>{ m.totalGal }</td>
                  <td>{ m.avgGal }</td>
                </tr>
              ))
            }
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td><center><b>{ sumProp('totalGal', this.props.meterTotals) }</b></center></td>
                <td><center><b>{ avgProp('avgGal', this.props.meterTotals) }</b></center></td>
              </tr>
            </tfoot>
          </table>
        </li>
      </ul>
    )
  }
}

export default MeterSummary;




/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/dashboard/meter_summary.js